import { useCallback, useContext } from 'react';

import { createSearchClient } from '@/integrations/algolia/searchClientBuilder';
import type { ContactHit } from '@/integrations/algolia/types';
import { CONTACT_DETAILS } from '@/lib/const';
import { DraftModeContext } from '@/providers/DraftModeProvider/DraftModeContext';

export const useNativeEmail = (countryCode: string) => {
  const draftMode = useContext(DraftModeContext);

  const initiateNativeEmail = useCallback(async () => {
    const algoliaSearchClient = createSearchClient({
      isPreview: draftMode,
    });
    const index = algoliaSearchClient.initIndex(
      `${process.env.NEXT_PUBLIC_ENVIRONMENT_NAME}.CONTACT_CENTER`,
    );
    try {
      const { hits } = await index.search<Partial<ContactHit>>('', {
        filters: `country_code:${countryCode}`,
        attributesToRetrieve: ['email'],
      });
      const email =
        hits && hits.length && hits[0].email
          ? hits[0].email
          : CONTACT_DETAILS.DEFAULT?.contact_email;
      window.location.href = `mailto:${email}`;
    } catch (error) {
      console.error('Error fetching contact data:', error);
      window.location.href =
        CONTACT_DETAILS.DEFAULT?.contact_email ??
        'mailto:contact@breitling.com';
    }
  }, [countryCode]);

  return { initiateNativeEmail };
};
